import React, { useState, useMemo } from "react";
import { RadioButton } from "../RadioButton/RadioButton";
import { Option } from "../RadioButton/RadioButton.types";
import { Flex } from "../../primitives/Flex/Flex";

interface RadioGroupProps {
  options: Option[];
  value?: string;
  onChange: (option: Option) => void;
  dataCyPrefix?: string;
  orientation?: "horizontal" | "vertical";
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  options = [],
  value,
  onChange,
  dataCyPrefix,
  orientation = "vertical",
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(value || "");

  const handleChange = (option: Option) => {
    const value = option.value;
    setSelectedValue(value);
    onChange(option);
  };
  const groupName = useMemo(
    () => `radio-group-${Math.random().toString(36).slice(2)}`,
    []
  );

  return (
    <Flex
      role="radiogroup"
      aria-orientation={orientation}
      flexDirection={orientation === "horizontal" ? "row" : "column"}
      py="small"
      gap="large"
      alignItems="flex-start"
    >
      {options.map(({ label, value }, index) => (
        <RadioButton
          key={value}
          name={groupName}
          label={label}
          value={value}
          selected={selectedValue === value}
          onChange={handleChange}
          dataCy={dataCyPrefix ? `${dataCyPrefix}-${index}` : undefined}
        />
      ))}
    </Flex>
  );
};

export default RadioGroup;
